// extracted by mini-css-extract-plugin
export default {"index":"system-configurations_index__WCGlV","body":"system-configurations_body__-4x-O","toolbar":"system-configurations_toolbar__rqWS-"};